export * from './browser-state.interceptor';

import { BrowserStateInterceptor } from './browser-state.interceptor';
export const ALL_MAIN_INTERCEPTORS = [
    BrowserStateInterceptor
]